var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[(_vm.affiseVar)?_c('VarForm',{attrs:{"data":_vm.affiseVar,"onEdit":_vm.onVarEdit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }